export const INNER_SEPARATOR = '|';
export const ITEM_SEPARATOR = ';';
